import { render, staticRenderFns } from "./vModifyAdditionalCost.vue?vue&type=template&id=81646404&scoped=true"
import script from "./vModifyAdditionalCost.vue?vue&type=script&setup=true&lang=ts"
export * from "./vModifyAdditionalCost.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./vModifyAdditionalCost.vue?vue&type=style&index=0&id=81646404&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81646404",
  null
  
)

export default component.exports